export default () => ({
  allowedTags: ['a', 'span', 'br', 'b'],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
    span: ['class']
  },
  transformTags: {
    a(tagName, attributes) {
      return {
        tagName: 'a',
        attribs: {
          ...attributes,
          rel: 'noopener'
        }
      };
    }
  }
});
